<div id="login" class="container-fluid position-absolute" style="margin:0;padding:0;background:url(assets/images/fondo-azul.jpg) no-repeat center top;background-size:cover; height:100vh ">
    <!-- <div id="login"  style="height: 100vh;width:100vw;" [ngStyle]="{'background': 'url(assets/images/fondo-azul.jpg)'}"> -->
    <div class="account-pages mt-5 mb-5">
        <div class="container">
            <div class="row justify-content-center pb-0">
                <div class="col-md-8 col-lg-6 col-xl-4 login-spr px-0 pb-0">
                    <div class="card shadow-none ">
                        <div class="card-body p-3 ">
                            <div class="text-center w-75 m-auto">
                                <div class="auth-logo">
                                    <!-- <a href="index.html" class="logo logo-dark text-center">
                                      <span class="logo-lg">
                                          <img src="assets/images/logo-dark.png" alt="" height="22">
                                      </span>
                                  </a>
                                  <a href="index.html" class="logo logo-light text-center">
                                      <span class="logo-lg">
                                          <img src="assets/images/logo-light.png" alt="" height="22">
                                      </span>
                                  </a> -->

                                    <a href="index.html" class="logo logo-dark text-center">
                                        <span class="logo-lg">
                                          <img src="../../../../assets/images/icono_siipne.png" alt="" height="22">
                                      </span>
                                    </a>
                                    <a href="index.html" class="logo logo-light text-center">
                                        <span class="logo-lg">
                                          <img src="../../../../assets/images/icono_siipne.png" alt="" height="22">
                                      </span>
                                    </a>

                                </div>
                                <p class="text-muted mb-4 mt-3">ERROR 404!!</p>
                            </div>

                        </div>
                        <!-- end card-body -->
                    </div>
                    <!-- end card -->
                    <!-- end row -->

                </div>
                <!-- end col -->
            </div>
            <!-- end row -->
        </div>
        <!-- end container -->
    </div>
    <!-- end page -->

</div>

<div id="pageNotFound" class="container-fluid position-absolute" style="margin:0;padding:0;background:url(assets/images/fondo-azul.jpg) no-repeat center top;background-size:cover; height:100vh ">
    <!-- <div id="login"  style="height: 100vh;width:100vw;" [ngStyle]="{'background': 'url(assets/images/fondo-azul.jpg)'}"> -->
    <div class="account-pages mt-5 mb-5">
        <div class="container">
            <div class="row justify-content-center pb-0">
                <div class="col-md-10 col-lg-8 col-xl-6 login-spr px-0 pb-0">
                    <div class="card shadow-none ">
                        <div class="card-head p-3">
                            <div class="text-center w-100 m-auto align-middle">
                                <div class="text-center col-2 m-auto align-middle ">
                                    <img src="/assets/images/icons/advertising.svg">
                                </div>
                                <h1>
                                    Página no encontrada</h1>
                            </div>
                        </div>
                        <div class="card-body p-3 ">
                            <div class="text-center w-75 m-auto align-middle">

                                <h2>Error 404</h2>
                                <div class="row">
                                    <div>
                                        <p>Clic <strong> <a href="#/admin/dashboard">aquí</a> </strong> para ir a la página principal </p>
                                    </div>
                                </div>


                            </div>
                        </div>
                    </div>
                </div>
            </div>

        </div>
    </div>
</div>